var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"routes-list-new-item",attrs:{"tabindex":"0"},on:{"click":_vm.startNewRoute}},[_c('div',{staticClass:"routes-list-new-item__icon"},[_c('app-icon',{attrs:{"icon":"route-marker-template-new"}})],1),_c('div',{staticClass:"routes-list-new-item__title"},[_vm._v(" "+_vm._s(_vm.$t("routesList.newItemLabel"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }